module.exports = __webpack_public_path__ + "static/media/moon-dark.72eac399.svg";